<ng-container>
  <div
    class="business-category {{agentId ? 'brm-view' : 'bo-view' }} {{isMobileView ? 'mobile-view' : 'web-view'}} overflow-y-scroll"
    [ngSwitch]="currentStep">
    <div class="business-category-content">
      <ng-container *ngSwitchCase="CATEGORY_STEPS.ADD_EDIT_CATEGORY">
        <ng-container *ngTemplateOutlet="addEditCategory"></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="CATEGORY_STEPS.CATEGORIES_LIST">
        <ng-container *ngTemplateOutlet="listCategories"></ng-container>
        <ng-container *ngTemplateOutlet="uploadDocuments"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showDetailsModal">
  <ng-container *ngIf="!isMobileView else mobileDetails">
    <app-web-kamona-message-widget [modalType]="ModalTypeEnum.CUSTOM">
      <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
    </app-web-kamona-message-widget>
  </ng-container>
</ng-container>

<ng-template #mobileDetails>
  <app-mobile-kamona-message-widget [modalType]="ModalTypeEnum.CUSTOM" (emitCancel)="handleCloseDetailsModal()">
    <ng-container *ngTemplateOutlet="detailsContent">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<ng-template #detailsContent>
  <ng-container>
    <div class="flex flex-col gap-6 overflow-y-scroll max-h-[550px]">
      <img src="assets/images/svgs/info-icon.svg" class="w-12 h-12 mx-auto" alt="Definitions" />
      <h3 class="font-bold text-[20px] md:text-[24px] leading-7 text-center text-[#1a1a1a]">What is an Agent or a
        Merchant?
      </h3>

      <div class="flex gap-4 text-left" *ngFor="let item of classificationDefinitions">
        <img src="{{item.icon}}" class="w-[38px] h-[38px] object-cover" />
        <div>
          <h4 class="font-semibold md:text-[14px] text-[12px] mb-1 text-black">{{item.title}}</h4>
          <p class="text-[#808080] font-regular md:text-[12px] text-[11px]"> {{item.description}}</p>
        </div>
      </div>

      <app-custom-button text="Done" [isBlock]="true" state="lightsecondary" class="w-full mt-3"
        (click)="handleCloseDetailsModal()"></app-custom-button>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="showUploadImageErrorModal">
  <ng-container *ngIf="!isMobileView else mobileAlert">
    <app-web-kamona-message-widget [modalType]="ModalTypeEnum.CUSTOM">
      <ng-container *ngTemplateOutlet="invalidImageContent"></ng-container>
    </app-web-kamona-message-widget>
  </ng-container>
</ng-container>

<ng-template #mobileAlert>
  <app-mobile-kamona-message-widget [modalType]="ModalTypeEnum.CUSTOM" (emitCancel)="handleCloseAlertModal()">
    <ng-container *ngTemplateOutlet="invalidImageContent">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<ng-template #invalidImageContent>
  <div>
    <div class="flex justify-center">
      <img src="assets/images/svgs/wcl-full-repayment-overdue.svg" class="w-[45px] h-[45px]" />
    </div>

    <h3 class="text-black text-[20px] md:text-[24px] font-bold mt-4 mb-2 text-center">
      {{uploadImageError}}
    </h3>
    <p class="md:text-[14px] text-[12px] text-[#1a1a1a] mb-6 text-center">
      Make sure your photo clearly shows the front of your shop with the sign or logo.
    </p>

    <div class="flex items-center gap-2 justify-center relative">
      <div class="absolute w-full top-[8px] left-0 bg-[#CED6E3] h-[1px]"></div>
      <h4 class="text-[12px] font-bold text-[#1a1a1a] relative bg-white px-4 mx-auto">
        Sample
      </h4>
    </div>

    <img src="assets/images/storefront-sample-lg.png" alt="Sample Storefront image" width="100%"
      class="w-full mt-2 mb-6 inline-block max-w-[400px] min-h-[238px] object-contain rounded-lg" />

    <app-custom-button state="lightsecondary" text="Try again" class="min-w-[335px] max-w-[350px]"
      (click)="handleCloseAlertModal()"></app-custom-button>
  </div>
</ng-template>

<ng-template #addEditCategory>
  <section class="business-category-web">
    <div class="text-[20px] md:text-[24px] font-bold text-black" data-test-id="business-details-title">
      Business details
    </div>
    <div class="text-[12px] md:text-[14px] font-normal text-black my-1">
      Please provide the required information
    </div>

    <form nz-form [formGroup]="form" autocomplete="off" class="login-form m-t-20 custom-moniepoint-select">
      <ng-container *ngTemplateOutlet="businessDetailsInfo"></ng-container>
      <div class="m-t-24 flex w-full {{isMobileView ? 'flex-col' : 'flex-row gap-6'}}">
        <div class="w-full">
          <nz-form-item>
            <nz-form-control>
              <nz-select [nzSuffixIcon]="plainCaretDown" formControlName="businessId" [nzLoading]="loadingCategories"
                nzPlaceHolder="{{'moniepoint.select_business' | translate}}"
                class="{{isPOSServiceSelected ? 'border border-[#E94444] rounded-md' : ''}}">
                <nz-option *ngFor="let item of categories" [nzLabel]="item.label" [nzValue]="item.label">
                  {{item.label}}
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="w-full">
          <nz-form-item>
            <nz-form-control>
              <nz-select [nzSuffixIcon]="plainCaretDown" [nzLoading]="loadingSubCategories"
                class="{{isPOSServiceSelected ? 'border border-[#E94444] rounded-md' : ''}}"
                nzPlaceHolder="{{'moniepoint.select_sub_category' | translate}}" formControlName="businessTypeId">
                <nz-option *ngFor="let item of subCategories" [nzLabel]="item.label" [nzValue]="item.label">
                  {{item.label}}
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <ng-container *ngTemplateOutlet="posServicesInfo"></ng-container>
    <app-custom-error-display [errorMessage]="errorMessage" designType="KAMONA_DESIGN"></app-custom-error-display>

    <div class="md:mt-16 mt-6 flex md:justify-end gap-2">
      <app-custom-button state="text" text="Back" class="md:w-auto w-full" (click)="handleBack()"></app-custom-button>
      <app-custom-button [isDisabled]="disableUpdateCategory" class="md:w-auto w-full" [isBlock]="true" state="primary"
        text="Next" (click)="handleSaveCategory()"> </app-custom-button>
    </div>
  </section>
</ng-template>

<ng-template #listCategories>
  <section>
    <div class="text-[24px] font-bold text-black hidden-xs">
      {{'moniepoint.business_Type' | translate }}
    </div>
    <div class="text-[14px] font-normal text-black my-1 hidden-xs">
      {{'moniepoint.category_business' | translate }}
    </div>

    <h4 class="text-[12px] font-medium mb-4 mt-8 list-section-title">
      Business Information
    </h4>

    <section class="rounded-xl border border-[#E5E5E5] bg-[#f8f8f8]">
      <div class="flex p-4 gap-4">
        <img src="assets/images/svgs/blue-plain-info.svg" class="w-6 h-6 mt-1" />
        <p class="text-[#1A1A1A] font-medium text-[12px] md:text-[14px]">Your business type is <b
            class="font-bold">{{businessClassification | capitalizeOnlyFirstLetter}}</b>
          <ng-container *ngIf="isUnclassified else selectedCategories">. Please select a category your business falls
            under. </ng-container>
          <span class="text-[#0361F0] text-[11px] md:text-[12px] font-medium cursor-pointer"
            (click)="handleOpenDetailsModal()">Learn More</span>
        </p>
      </div>

      <div class="rounded-xl bg-white p-4">
        <ng-container *ngIf="loading">
          <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 2 }"></nz-skeleton>
        </ng-container>

        <div *ngIf="!loading" class="flex flex-col gap-6 mt-1 mb-1">
          <div class="flex items-center justify-between"
            *ngFor="let categoryDetail of categoriesFormList; let idx = index">
            <div class="flex flex-col">
              <h5 class="md:text-[16px] text-[14px] font-semibold leading-6 business-category-name">
                {{categoryDetail.businessCategoryName}}
              </h5>
              <p class="text-[#808080] font-medium md:text-[14px] text-[12px]">
                {{categoryDetail.name}}
              </p>
            </div>

            <div class="flex gap-3">
              <img src="assets/images/svgs/editIcon.svg" data-test-id="edit-icon"
                class="w-[24px] h-[24px] {{isUnderReview ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}}"
                (click)="handleEditCategory(idx)" alt="Edit Business Type" />

              <img src="assets/images/svgs/trash-red.svg" data-test-id="delete-icon"
                class="w-[24px] h-[24px] {{isUnderReview ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}}"
                (click)="handleDeleteCategory(idx)" alt="Delete Business Type" *ngIf="categoriesFormList.length > 1" />
            </div>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="addNewCategory"></ng-container>
        <ng-container *ngTemplateOutlet="underReview"></ng-container>

      </div>
    </section>
  </section>
</ng-template>

<ng-template #uploadDocuments>
  <ng-container *ngTemplateOutlet="uploadStoreFrontImage"></ng-container>
  <ng-container *ngTemplateOutlet="provideJustification"></ng-container>

  <ng-container *ngIf="agentId else submitButtonWithAccess">
    <ng-container *ngTemplateOutlet="submitButton"></ng-container>
  </ng-container>

</ng-template>

<ng-template #uploadStoreFrontImage>
  <div *ngIf="showUploadImageSection">
    <h4 class="text-[12px] font-medium mb-4 mt-8 list-section-title">
      Storefront Photo
    </h4>

    <section class="rounded-xl border border-[#E5E5E5]">
      <ng-container *ngTemplateOutlet="existingImage"></ng-container>
      <ng-container *ngTemplateOutlet="uploadImageWithInstructions"></ng-container>
    </section>
  </div>
</ng-template>

<ng-template #provideJustification>
  <div class="mt-10" *ngIf="showProvideJustification">
    <h4 class="text-[12px] font-medium mb-4 mt-8 list-section-title">
      Justification
    </h4>

    <section class="rounded-xl border border-[#E5E5E5]">
      <div class="p-4">
        <h4 class="text-[14px] font-semibold text-[#000000]">
          Please provide a short reason for the change
        </h4>
        <p class="text-[12px] font-medium mb-4 text-[#333333]">
          I am updating my business type because...
        </p>

        <div nz-col nzSpan="24" class="text-area">
          <textarea nz-input placeholder="Reason" [nzAutosize]="{ minRows: 5, maxRows: 8 }" [(ngModel)]="justificationNote"
            class="bg-[#F3F4F7] rounded-md border border-[#F3F4F7]" [maxlength]="MAX_JUSTIFICATION_NOTE_LENGTH"></textarea>
          <div class="flex justify-between text-[11px] mt-2">
            <div class="flex gap-2 items-center">
              <ng-container *ngIf="justificationNote?.length < MIN_JUSTIFICATION_NOTE_LENGTH">
                <img src="assets/images/svgs/info-icon.svg" class="w-3 h-3" alt="info" /> Minimum 10 characters required
              </ng-container>
            </div>
            <p> {{justificationNote?.length}}/{{MAX_JUSTIFICATION_NOTE_LENGTH}}</p>
          </div>
          </div>
          </div>
    </section>
  </div>
</ng-template>

<ng-template #addNewCategory>
  <ng-container *ngIf="showAddNewCategory">
    <div class="mt-5 flex items-center justify-center cursor-pointer" (click)="handleCreateCategory()">
      <img src="assets/images/svgs/blue-plus-icon.svg" class="w-7 h-7" alt="Add Business Type" />
      <span class="text-[#0361F0] text-[14px] font-medium text-center">Add New Category</span>
    </div>
  </ng-container>
</ng-template>

<ng-template #underReview>
  <div class="flex p-4 gap-4 rounded-lg bg-[#FEF9EF] mt-5" *ngIf="reviewWarning && isUnderReview">
    <img src="assets/images/svgs/alert-warning.svg" class="w-6 h-6 mt-1" />
    <p class="text-black text-[12px]">
      {{reviewWarning}}
    </p>
  </div>
</ng-template>

<ng-template #businessDetailsInfo>
  <div class="flex p-4 gap-4 rounded-lg bg-[#E6EEFD] mt-8">
    <img src="assets/images/svgs/blue-plain-info.svg" class="w-6 h-6 mt-1" />
    <p class="text-black text-[12px]">
      Please ensure you select the right category for this business. Any incorrect or negligent classification will
      result in penalties.
    </p>
  </div>
</ng-template>

<ng-template #posServicesInfo>
  <div *ngIf="isPOSServiceSelected">
    <p class="text-[#E94444] text-[12px] font-medium">You cannot combine agency banking and merchant categories</p>
  </div>
</ng-template>

<ng-template #plainCaretDown>
  <img src="assets/images/svgs/chevron-plain.svg" class="w-[24px] h-[24px] rotate-90" />
</ng-template>

<ng-template #caretIcon>
  <ng-container *ngIf="showStoreFrontSample else caretDown">
    <img src="assets/images/dashboard/chevron-up.svg" class="w-[18px] h-[18px]" />
  </ng-container>
</ng-template>

<ng-template #caretDown>
  <img src="assets/images/dashboard/chevron-down.svg" class="w-[16px] h-[16px]" />
</ng-template>

<ng-template #editIcon>
  <img src="assets/images/svgs/editIcon.svg" class="w-[24px] h-[24px]" alt="Edit Image" />
</ng-template>

<ng-template #submitButton>
  <div class="mt-10" *ngIf="!isUnderReview">
    <nz-skeleton [nzActive]="true" *ngIf="loading" [nzParagraph]="{ rows: 1, width: '100%' }"
      [nzTitle]="false"></nz-skeleton>
    <app-custom-button *ngIf="!loading" [isBlock]="true" text="Save Changes" (click)="handleSubmit()"
      [isSubmitting]="isSavingChanges" [isDisabled]="isSubmitDisabled" />
  </div>
</ng-template>

<ng-template #submitButtonWithAccess>
  <ng-container *appViewAccess="'mab_fo_su_update_business_types'">
    <ng-container *ngTemplateOutlet="submitButton"></ng-container>
  </ng-container>
</ng-template>

<ng-template #uploadImageWithInstructions>
  <div *ngIf="showUploadImage" class="p-4">
    <h4 class="text-[14px] font-semibold text-[#000000]">
      Upload storefront photo
    </h4>
    <p class="text-[12px] font-medium mb-4 text-[#333333]">
      Please share a clear photo of your shopfront including the signpost.
    </p>
    <app-custom-image-uploader (getFile)="handleGetFile($event)" [useReferenceResponse]="true" [convertToBase64]="false"
      [useDashboardServiceUpload]="true" [uploadType]="'TYPE_1'" [maxFileSize]="maxStoreFrontFileSize"
      [allowedFormats]="['.jpeg', '.png', '.jpg']" [hideTitle]="!!storeFrontImg"
      [title]="storeFrontImg ? 'Upload New Image' : ''">
    </app-custom-image-uploader>


    <div class="mt-2">
      <img *ngIf="showStoreFrontSample" src="assets/images/storefront-sample.png" alt="Sample Storefront image"
        class="w-full my-2 inline-block" />
      <app-custom-button type="link" [text]="showStoreFrontSample ? 'Close sample ' : 'Show sample '"
        [suffixIcon]="caretIcon" [isBlock]="true" (click)="toggleSample()"
        class="flex items-center gap-1 justify-center">
      </app-custom-button>
    </div>
  </div>
</ng-template>

<ng-template #existingImage>
  <section *ngIf="showExistingImage" class="p-4">
    <img [src]="storeFrontImg" alt="Storefront image" class="w-full rounded-xl" *ngIf="!isLoadingStorefrontImg" />
    <nz-skeleton *ngIf="isLoadingStorefrontImg" [nzActive]="true" [nzTitle]="false"
      [nzParagraph]="{ rows: 5, width: '100%' }"></nz-skeleton>

    <app-custom-button text="Upload a Different image" *ngIf="!isUnderReview" state="text"
      (click)="switchToImageUpload()" class="flex mx-auto mt-3 justify-center items-center gap-2"
      [prefixIcon]="editIcon"></app-custom-button>
  </section>
</ng-template>

<ng-template #selectedCategories>
  based on your selected categories. This business type cannot be combined with {{nextClassification |
  capitalizeOnlyFirstLetter}} categories.
</ng-template>
